import styled from "styled-components";

export const Header = styled.header`
  position: fixed;
  z-index: 1010;
  top: 46px;
  left: 0;
  width: 100%;
  transition: ease-in-out 0.2s all;

  &.nav-position {
    top: 0;
  }

  .navbar {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 32px;
    border: 2px solid #fff;
    border-radius: 500px;
    background-color: #5A89E1;

    .brand {
      display: block;
      flex: 210px 0 0;
      line-height: 0;
    }

    .menu {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-left: 30px;
      list-style: none;
      transform: translateY(2px);

      a {
        font-size: 18px;
        font-weight: 700;
        color: #0B182F;

        &.active,
        &:hover {
          color: #fff;
        }
      }
    }
  }

  @media screen and (max-width: 1367px) {
    top: 23px;
    .navbar {
      .brand {
        display: unset;
        flex: 140px 0 0;
      }
      .menu a{
        font-size: 16px
      }
    }
  }
`;
